module.exports = __webpack_public_path__ + "img/html.c186f8e9.png";